import { Campaign, CampaignConfig } from './types';

export function getActiveCampaigns(campaigns: Campaign[]): Campaign[] {
  const now = new Date();

  return campaigns
    .filter((campaign) => {
      if (campaign.visibility_status !== 'enabled') return false;
      const startTime = new Date(campaign.start_time);
      const endTime = new Date(campaign.end_time);
      return now >= startTime && now <= endTime;
    })
    .sort((a, b) => a.priority - b.priority);
}

export function getCampaignByProduct(
  campaigns: Campaign[],
  product: string,
): Campaign | undefined {
  if (product === 'cgm' || product === 'm1') {
    return campaigns.find(
      (campaign) => campaign.product === 'cgm' || campaign.product === 'm1',
    );
  }

  return campaigns.find((campaign) => campaign.product === product);
}

export function getCampaignConfig(
  campaign: Campaign | undefined,
): CampaignConfig | undefined {
  if (!campaign) {
    return undefined;
  }

  return {
    discountCode: campaign.discount_code,
    discount: campaign.discount_value,
    discountType: campaign.discount_type,
    active: true,
    product: campaign.product,
  };
}
